import styled from "styled-components";
import {styledByDevice} from "../../../../../themes/architecture/styled-by-device";

const PcBox = styled.div`
  display: flex;
  align-items: center;
`;

const MobileBox = styled(PcBox)`
  flex-direction: column;
  width: 100%;
  padding: 0.5rem 1.5rem;
  background: ${props => props.theme.colors.backgroundDark};

  .cgp-dk & {
    flex-direction: row-reverse;
  }
`;

export const RegulatoryDataDefaultBox = styledByDevice(PcBox, MobileBox);
